import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { useLocation, useHistory } from "react-router-dom";
import axiosInstance from "../config/axios-instance";
import Sidebar from "../components/Library/Sidebar";
import Content from "../components/Library/Content";
import LibraryDrawer from "../components/Library/LibraryDrawer";
import "../sass/Library.scss";
import Head from "../components/Head";

const Library = () => {
  const [isTrims, setIsTrims] = useState(false);
  const [isDenim, setIsDenim] = useState(true);
  const [selectedItem, setSelectedItem] = useState(null);
  const [visible, setVisible] = useState(false);
  const [queries, setQueries] = useState<any>([]);
  function useQueryy() {
    return new URLSearchParams(useLocation().search);
  }
  const query = useQueryy();
  const history = useHistory();
  const [url, setUrl] = useState(
    `/fabrics?fabric_type=${query.get("fabric_type")}&page=${query.get("page")}`
  );

  const showDrawer = () => {
    setVisible(true);
  };
  const onClose = () => {
    setVisible(false);
  };
  // colors
  const { isLoading: colorsIsLoading, data: colors } = useQuery(
    "color",
    () => fetchType("colors"),
    { keepPreviousData: true }
  );
  // elasticity
  const { isLoading: elasticityIsLoading, data: elasticity } = useQuery(
    "elasticities",
    () => fetchType("elasticities"),
    {
      keepPreviousData: true,
    }
  );
  // weight
  const { isLoading: weightIsLoading, data: weight } = useQuery(
    "weights",
    () => fetchType("weights"),
    {
      keepPreviousData: true,
    }
  );
  // // fibers
  // const { isLoading: fiberIsLoading, data: fibers } = useQuery(
  //   "fibers",
  //   () => fetchType("fibers"),
  //   {
  //     keepPreviousData: true,
  //   }
  // );
  // fibers
  const { isLoading: compositionsIsLoading, data: compositions } = useQuery(
    "compositions",
    () => fetchType("compositions"),
    {
      keepPreviousData: true,
    }
  );
  // washes
  const { data: washes } = useQuery("washes", () => fetchType("washes"), {
    keepPreviousData: true,
  });
  // content
  const { data, isLoading, isFetching, refetch } = useQuery(
    ["content", query.get("fabric_type"), url],
    () => fetchData(url),
    {
      keepPreviousData: true,
    }
  );

  useEffect(() => {
    if (query.get("fabric_type") === "knit") {
      history.push("/library?fabric_type=knit&page=1");
      setUrl("/fabrics?fabric_type=knit&page=1");
    } else {
      history.push("/library?fabric_type=denim&page=1");
      setUrl("/fabrics?fabric_type=denim&page=1");
    }
  }, [isDenim]);

  const fetchType = (type: string) => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/${type}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };
  const fetchData = (url: string) => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  };

  useEffect(() => {
    setUrl(
      `/fabrics?fabric_type=${query.get("fabric_type")}&page=${query.get(
        "page"
      )}`.concat("&" + queries.join("&"))
    );
  }, [queries]);

  const checkboxChange = (name: string, id: number, checked: boolean) => {
    const element = name + "=" + id;
    if (checked) {
      var exists = queries.filter((query: any) => query.includes(name));
      if (exists.length === 0) {
        setQueries([...queries, element]);
      } else {
        var newQueryVal = exists[0].concat("," + id);
        setQueries(
          queries.map((el: any) => (el.includes(name) ? newQueryVal : el))
        );
      }
    } else if (!checked) {
      var exist = queries.filter((query: any) => query.includes(name))[0];
      if (exist.includes(",") === false) {
        setQueries(queries.filter((el: any) => !el.includes(name)));
      } else if (exist.indexOf(id) === exist.length - id.toString().length) {
        let newQuery = exist.substr(
          0,
          exist.length - (id.toString().length + 1)
        );
        setQueries(
          queries.map((el: any) => (el.includes(name) ? newQuery : el))
        );
      } else {
        let newQuery = exist.replace(id + ",", "");
        setQueries(
          queries.map((el: any) => (el.includes(name) ? newQuery : el))
        );
      }
    }
  };

  return (
    <div className="bookings-page">
      <Head title="DEMCO's Library" />
      <header>
        <div className="header-content">
          <div className="navbarr">
            <a href="#side" id="toggle-filter-menu">
              <span className="material-icons-sharp menu-icon">menu</span>
            </a>
          </div>
        </div>
      </header>
      <span id="pop"></span>
      <Sidebar
        setIsTrims={setIsTrims}
        isTrims={isTrims}
        isDenim={isDenim}
        setIsDenim={setIsDenim}
        colors={colors?.data}
        colorsIsLoading={colorsIsLoading}
        elasticityIsLoading={elasticityIsLoading}
        elasticity={elasticity?.data}
        weightIsLoading={weightIsLoading}
        weight={weight?.data}
        // fiberIsLoading={fiberIsLoading}
        // fibers={fibers?.data}
        compositionsIsLoading={compositionsIsLoading}
        compositions={compositions?.data}
        checkboxChange={checkboxChange}
        queryFabricType={query.get("fabric_type")}
      />
      <main id="main-doc">
        <div className="container-fluid">
          <section className="main-section" id="introduction">
            <Content
              content={data?.data}
              isLoading={isLoading}
              isFetching={isFetching}
              currentPage={query.get("page")}
              setSelectedItem={(item: any) => {
                setSelectedItem(item);
                showDrawer();
              }}
            />
          </section>
        </div>
      </main>
      <LibraryDrawer
        elasticity={elasticity?.data}
        colors={colors?.data}
        // fibers={fibers?.data}
        washes={washes?.data}
        weights={weight?.data}
        item={selectedItem}
        refetch={refetch}
        onClose={() => {
          onClose();
          setSelectedItem(null);
        }}
        visible={visible}
      />
    </div>
  );
};

export default Library;
